var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaytest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Video_on_Logo",
    "data-name": "Video on Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 650.648,
    height: 654,
    viewBox: "0 0 650.648 654",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a14ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#785cff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2563",
    "data-name": "Group 2563",
    opacity: 0.4,
    style: {
      mixBlendMode: "hard-light",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2562",
    "data-name": "Group 2562",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17247",
    "data-name": "Path 17247",
    d: "M600.15,318.717c30.1-17.8,57.854-27.026,57.854-74.03V121.734L346.45,297.267V654l144.445-82.1V380.111s81.441-44.949,109.255-61.395ZM635.34,82.1,493.723,0,326.909,96.258S206.25,27.207,204.29,26.019c-24.111-14.613-54.748-24.693-80.8-3.37L70.477,52.557C52.077,63.7,36.421,72.306,17.9,82.1,88.093,123.3,326.62,263.3,326.62,263.3Z",
    transform: "translate(-7.356)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17249",
    "data-name": "Path 17249",
    d: "M57.722,398.29C27.691,380.55,0,371.35,0,324.494V201.93L310.845,376.909V732.515L166.729,650.671V459.491s-81.255-44.807-109.006-61.2Z",
    transform: "translate(0 -79.445)",
    fill: "url(#linear-gradient)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2441",
    "data-name": "Group 2441",
    transform: "translate(257.646 182.182)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 74.737,
    cy: 74.737,
    r: 74.737,
    transform: "translate(0 0)",
    fill: "#fff",
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2428",
    "data-name": "Group 2428",
    transform: "translate(23.489 23.489)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3-2",
    "data-name": "Ellipse 3",
    cx: 51.249,
    cy: 51.249,
    r: 51.249,
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    d: "M13.187,3.27a2,2,0,0,1,3.522,0l11.6,21.541a2,2,0,0,1-1.761,2.948H3.348a2,2,0,0,1-1.761-2.948Z",
    transform: "translate(70.467 36.301) rotate(90)",
    fill: "url(#linear-gradient)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaytest);
export default __webpack_public_path__ + "static/media/playtest.9c785deefe6d40916db723f1a653df53.svg";
export { ForwardRef as ReactComponent };